import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { Box, Flex } from "sprout-ui-primitives";
import Head from "@sprout/client-layout/dist/Head";
import { Authenticate } from "sprout-ui-dom/dist/Authenticate";
import { Sprout } from "sprout-ui-dom/dist/Sprout";
const LoginPage = ()=>{
    const { replace  } = useHistory();
    const { pathname , search  } = useLocation();
    const isSignUp = pathname === "/signup";
    const onCalloutClick = useCallback(()=>{
        replace({
            pathname: isSignUp ? "/login" : "/signup",
            search
        });
    }, [
        isSignUp,
        replace,
        search
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Head, {
                title: `${isSignUp ? "Sign up" : "Sign in"} | Sprout`
            }),
            /*#__PURE__*/ _jsx(Flex, {
                justifyContent: "center",
                my: 3,
                children: /*#__PURE__*/ _jsx(Sprout, {
                    url: "/"
                })
            }),
            /*#__PURE__*/ _jsx(Flex, {
                flex: "1",
                pb: 12,
                px: 3,
                children: /*#__PURE__*/ _jsx(Box, {
                    py: [
                        "32px",
                        "64px"
                    ],
                    px: [
                        "16px",
                        "32px",
                        "64px"
                    ],
                    bg: "white.100",
                    m: "auto",
                    borderRadius: "30px",
                    children: /*#__PURE__*/ _jsx(Authenticate, {
                        variant: isSignUp ? "signup" : "signin",
                        onCalloutClick: onCalloutClick
                    })
                })
            })
        ]
    });
};
export default LoginPage;
